export const formatPrice = (value: unknown): string => {
  try {
    const num = typeof value === 'number' ? value : Number(value);

    if (Number.isNaN(num)) {
      return '₹0.00';
    }

    return `₹${num.toFixed(2)}`;
  } catch {
    return '₹0.00';
  }
};

export const toNumber = (value: unknown): number => {
  try {
    const num = typeof value === 'number' ? value : Number(value);
    return Number.isNaN(num) ? 0 : num;
  } catch {
    return 0;
  }
};
